import React, { useContext } from 'react';
import { FaTimes } from 'react-icons/fa';
import { ComponentContext } from '../../context/componentContext';

const Support = () => {
  const { toggleSupport, handleToggleSupport } = useContext(ComponentContext);

  return (
    <div className={toggleSupport ? 'show transition-opacity duration-200 ease-in-out' : 'hidden'}>
      <div className="fixed z-50 modal-bg">
        <div className="flex flex-wrap items-center justify-center h-screen w-screen">
          <div className="relative bg-white w-85 md:w-110 rounded shadow-cfw h-85 md:h-90 p-10">
            <div
              onClick={handleToggleSupport}
              className="absolute right-0 top-0 cursor-pointer text-cf-300 mt-6 mr-6 text-2xl"
            >
              <FaTimes />
            </div>

            <h6 className="text-center mt-6">
              Welcome to Complete Farmer <br />
              customer service
            </h6>
            <div className="relative bg-cf-200 mt-6">
              <div className="absolute left-0 top-0 bottom-0 border-l-8 w-16 border-cf-300"></div>
              <div className="p-6 text-xs md:text-sm text-center">
                <p>
                  Here at Complete Farmer, we believe in building a great experience culture with
                  our customers.
                </p>
                <p className="py-2">Contact our customer service support on:</p>
                <ul>
                  <li>
                    <span className="text-cf-300">Phone</span>:{' '}
                    <a
                      className="hover:text-cf-300"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="tel:+233201468190"
                    >
                      ++233-201-468-190
                    </a>
                  </li>
                  <li>
                    <span className="text-cf-300">WhatsApp</span>:{' '}
                    <a
                      className="hover:text-cf-300"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://wa.me/233201468190?text=complete%20farmer%20support"
                    >
                      ++233-201-468-190
                    </a>
                  </li>
                  <li>
                    <span className="text-cf-300">Email</span>:{' '}
                    <a className="hover:text-cf-300" href="mailto:support@completefarmer.com">
                      support@completefarmer.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
